<template>
  <el-dialog
    title="Excel导入"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    custom-class="custom_dialog"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="importForm"
          ref="importForm"
          label-width="110px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'left'"
        >
          <el-form-item label="选项分组：" prop="ProjectGroupID">
            <el-select
              v-model="projectGroupID"
              placeholder="请选择或者输入分组"
              default-first-option
              @change="
                $forceUpdate()
                groupChange
              "
            >
              <el-option
                v-for="item in projectGroupList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择文件：">
            <el-upload
              class="upload-demo"
              ref="upload"
              :file-list="fileList"
              :data="importForm"
              :headers="uploadHeaders"
              action="/api/VoteProject/ImportCommonGroupProjects"
              :show-file-list="true"
              :limit="1"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-change="changeFile"
              :before-upload="beforeUpload"
              :auto-upload="false"
            >
              <el-button slot="trigger" size="small" type="primary">
                选取文件
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="importGroupProjects('importForm')"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import voteProjectApi from '../../api/vote/voteProject'
export default {
  name: 'ImportExcel',
  data () {
    return {
      importForm: {
        ProjectGroupID: null,
        MeetingID: null
      },
      importFormRules: {
        ProjectGroupID: [
          { required: true, message: '请输入分组名称', trigger: 'blur' },
          { min: 1, max: 50, message: '分组名称长度最多50个字符。', trigger: 'blur' }]
      },
      loading: false,
      dialogFormVisible: false,
      projectGroupID: null,
      projectGroupList: [],
      listQuery: {
        meetingId: null,
        maxResultCount: 10000,
        skipCount: 0
      },
      fileList: [],
      uploadHeaders: {
        Authorization: null
      }
    }
  },
  props: {
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getDefaultProjectGroup: function () {
      const _this = this
      voteProjectApi.getDefaultProjectGroup({
        meetingId: _this.importForm.MeetingID
      }).then(data => {
        if (data) {
          _this.importForm.ProjectGroupID = data.Id
        } else {
          _this.projectGroupList.unshift({ Id: null, Name: '默认组', Sort: 0 })
          _this.importForm.ProjectGroupID = null
        }
        if (_this.projectGroupID) {
          _this.importForm.ProjectGroupID = _this.projectGroupID
        }
        _this.groupChange(_this.importForm.ProjectGroupID)
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getProjectGroups: function () {
      const _this = this
      _this.openLoading()
      voteProjectApi.getProjectGroups(_this.listQuery).then(data => {
        _this.projectGroupList = data.Items
        _this.getDefaultProjectGroup()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    openImportExcel: function (projectGroupID, meetingId) {
      this.openLoading()
      this.dialogFormVisible = true
      this.projectGroupID = projectGroupID
      this.listQuery.meetingId = meetingId
      this.importForm = {}
      this.fileList = []
      this.importForm.MeetingID = meetingId
      this.getProjectGroups()
      const state = JSON.parse(window.localStorage.getItem('state'))
      this.uploadHeaders.Authorization = 'Bearer ' + state.token
    },
    groupChange: function (key) {
      this.projectGroupID = key
      this.importForm.ProjectGroupID = this.projectGroupID
    },
    changeFile (file, filelist) { // 文件状态改变时的钩子 把filelist 赋值给data中的filelist
      this.fileList = filelist
    },
    handleSuccess (res, file) {
      this.$message({
        showClose: true,
        type: 'success',
        message: '导入成功！',
        customClass: 'custom_message'
      })
      this.dialogFormVisible = false
      this.fatherSubmitDialog(res)
    },
    handleError (err, file, fileList) {
      this.$message({
        showClose: true,
        type: 'error',
        message: err.message,
        customClass: 'custom_message'
      })
    },
    beforeUpload (file) {
      const isJPG = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '只能导入excel文件！',
          customClass: 'custom_message'
        })
      }
      if (!isLt2M) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '导入文件大小不能超过 10MB！',
          customClass: 'custom_message'
        })
      }
      return isJPG && isLt2M
    },
    importGroupProjects: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.fileList.length) { // 判断data中的filelist是否有数据 没有则未选中文件
            this.$refs.upload.submit() // 手动上传文件
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: '请选择文件！',
              customClass: 'custom_message'
            })
          }
        } else {
          return false
        }
      })
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
